import React from "react";
import moment from "moment";
import {Calendar} from "antd";

/*
dates = [
  {
    date: moment(),
    text: 'stuff',
    target: 'url',
    priority: 3,
    color: 'warn',
  }
]
*/

export class Schedule extends React.Component {
  static defaultProps = {
    dates: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      mode: 'month'
    };
    if (!this.props.value) {
      this.state.selectedDate = moment();
    }
  }

  handleSelect = (day) => {
    const { onChange } = this.props;
    if (!this.props.value) {
      this.setState({
        selectedDate: day
      });
    }
    if (onChange) {
      onChange(day, this.state.mode);
    }
  };

  handlePanelChange = (day, mode) => {
    const { onChange, value } = this.props;
    if (!value) {
      this.setState({
        mode: mode,
        selectedDate: day
      });
    } else {
      this.setState({
        mode: mode,
      });
    }
    if (onChange) {
      onChange(day, mode, false);
    }
  };

  dateCellRender = (value) => {
    const { callouts } = this.props;
    if (callouts && callouts.length) {
      const calloutMap = callouts.filter(callout => callout.date.isSame(value, 'day'));
      const total = (calloutMap && calloutMap.length) ? calloutMap[0].count : 0;
      if (total > 0) {
        return (
          <span className='date-cell'>{total}</span>
        );
      } else return null;
    } else {
      return null;
    }
  };

  monthCellRender = (value) => {
    const { callouts } = this.props;
    if (callouts) {
      const calloutMap = callouts.filter(callout => callout.date.isSame(value, 'month'));
      const total = (calloutMap && calloutMap.length) ? calloutMap.map(a => a.count).reduce((a, b) => a+b) : 0;
      if (total > 0) {
        return (
          <span className='date-cell month-cell'>{total}</span>
        );
      } else return null;
    } else {
      return null;
    }
  };

  render() {
    const { selectedDate, mode } = this.state;
    const { value } = this.props;
    let whichValue = value || selectedDate || moment();
    return (
      <div
        className='schedule border-primary-2'
      >
        <div>
          { mode === 'month' ?
            whichValue.format('dddd, MMMM Do YYYY')
            :
            whichValue.format('MMMM YYYY')
          }
        </div>
        <Calendar
          dateCellRender={this.dateCellRender}
          monthCellRender={this.monthCellRender}
          value={whichValue}
          fullscreen={false}
          defaultValue={moment()}
          onSelect={this.handleSelect}
          onPanelChange={this.handlePanelChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Boilerplate/Schedule.js